module.exports = __webpack_public_path__ + "img/car_shina2_12.aa206cab.jpg";